module.exports = __webpack_public_path__ + "assets/icons/domain-63a4.svg";